import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext.js";
import { Cookies } from '../../index.js';
import axios from 'axios';
import { ClipLoader } from 'react-spinners';
import { useSelector, useDispatch } from 'react-redux';
import Service from './service';
import Search from './search';
import Pagination from './Pagination';
import { update_scams_lists_search, update_scams_lists_show } from './../../order/orders/actions.js';

// --- Icons (Chỉnh màu sang tông Tím/Hồng nhạt cho hợp nền) ---
const IconSource = () => <svg className="w-3 h-3 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>;
const IconIdentity = () => <svg className="w-3 h-3 text-pink-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>;
const IconTime = () => <svg className="w-3 h-3 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>;

const TaskList = () => {
    let { slug_1, slug_2 } = useParams();
    const dispatch = useDispatch();

    // --- State Logic (Giữ nguyên 100%) ---
    const [id_categories3, set_id_categories3] = useState('');
    const [nutorder, setnutorder] = useState("Tra cứu"); 
    const [inputlienket, setinputlienket] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const [total_lists, set_total_lists] = useState(null);
    const [page, setPage] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);

    const scams_lists_search = useSelector(state => state.scams_lists_search);
    const scams_lists_show = useSelector(state => state.scams_lists_show);

    const set_scams_lists_search = (value) => dispatch(update_scams_lists_search(value));
    const set_scams_lists_show = (value) => dispatch(update_scams_lists_show(value));

    function laythongtin(category, mode) {
        if (page) {
            const myCookieValue = Cookies.get('apikey');
            const apiBase = (window.location.hostname.includes('hust.media') || window.location.hostname.includes('tecom.pro'))
                ? ''
                : 'https://hust.media';
            axios.get(`${apiBase}/api/scams_check/process/orders/transaction.php`, {
                params: {
                    apikey: myCookieValue,
                    category: category,
                    mode: mode,
                    listtrang: page
                }
            })
            .then(response => {
                setnutxuly(0);
                if (response.data.status == 0) {
                    alert_error(response.data.message);
                } else {
                    set_scams_lists_search(response.data.data);
                    set_total_lists(response.data.total_lists);
                    set_scams_lists_show(true);
                }
            })
            .catch(error => {
                set_scams_lists_show(true);
            });
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setPage(params.get('page') || 1);
        if (id_categories3) {
            set_scams_lists_show(false);
            laythongtin(id_categories3, "category");
        }
    }, [id_categories3]);

    useEffect(() => {
        if (inputlienket && nutxuly == 1) {
            setnutxuly(1);
            set_scams_lists_show(false);
            laythongtin(inputlienket, "search");
        }
    }, [nutxuly]);

    useEffect(() => {
        if (slug_2 == 'search') {
            set_scams_lists_show(false);
            set_id_categories3(null);
        } else if (!id_categories3) {
            set_id_categories3('full');
        }
    }, [slug_2]);

    useEffect(() => {
        set_scams_lists_show(false);
        setPage(page);
        if (id_categories3) {
            laythongtin(id_categories3, "category");
        }
    }, [page]);

    // --- RENDER SIÊU PHẨM ULTRA COMPACT ---
    return (
        <div className="mt-2 flex flex-col h-full w-full bg-transparent">
            {/* 1. Control Bar - Giảm opacity nền để hòa vào màu web */}
            <div className="w-full mb-2 px-2">
                {slug_2 == 'exchange' && (
                    <div className="bg-white/40 backdrop-blur-md rounded-xl p-1.5 shadow-sm border border-white/40">
                        <Service isOpen={isOpen} isOpen2={isOpen2} setIsOpen={setIsOpen} setIsOpen2={setIsOpen2} set_id_categories3={set_id_categories3} />
                    </div>
                )}
                {slug_2 == 'search' && (
                    <div className="bg-white/40 backdrop-blur-md rounded-xl p-1.5 shadow-sm border border-white/40">
                        <Search isOpen={isOpen} isOpen2={isOpen2} setIsOpen={setIsOpen} setIsOpen2={setIsOpen2} nutxuly={nutxuly} setnutxuly={setnutxuly} inputlienket={inputlienket} setinputlienket={setinputlienket} />
                    </div>
                )}
            </div>

            {/* 2. Main Content - Căn chiều cao khít */}
            <div className="flex-1 w-full px-2 pb-2 min-h-0 flex flex-col"> 
                
                {(scams_lists_show == false) ? (
                    <div className="flex flex-1 justify-center items-center">
                        <ClipLoader color="#db2777" size={35} speedMultiplier={0.8} />
                    </div>
                ) : (
                    <>
                        {(scams_lists_search == 'nothing') ? (
                            <div className="flex flex-1 flex-col justify-center items-center bg-white/30 backdrop-blur-lg rounded-2xl border border-white/40">
                                <span className="text-3xl opacity-40 mb-2">🛡️</span>
                                <span className="text-slate-600 font-medium text-xs">Chưa có dữ liệu</span>
                            </div>
                        ) : (
                            <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-[0_4px_30px_rgba(0,0,0,0.05)] border border-white/60 overflow-hidden flex flex-col">
                                
                                {/* 2.1 Table Header: Tông hồng nhạt, chữ đậm, siêu gọn */}
                                <div className="hidden md:grid grid-cols-12 gap-2 px-3 py-2 bg-white/40 border-b border-pink-100/50 text-[10px] font-extrabold text-pink-600 uppercase tracking-wider sticky top-0 z-10 backdrop-blur-md">
                                    <div className="col-span-2">Nguồn tin</div>
                                    <div className="col-span-3">Đối tượng định danh</div>
                                    <div className="col-span-4">Dữ liệu ghi nhận</div>
                                    <div className="col-span-2 text-center">Cập nhật</div>
                                    <div className="col-span-1 text-right">Chi tiết</div>
                                </div>

                                {/* 2.2 Table Body: Padding cực nhỏ (py-1.5), màu chữ slate-700 để nét */}
                                <div className="overflow-y-auto custom-scrollbar">
                                    <div className="divide-y divide-white/40">
                                        {scams_lists_search.map((task) => (
                                            <a
                                                key={task.id}
                                                href={task.url || "#"}
                                                className="group block cursor-pointer hover:bg-white/60 transition-colors duration-150"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                {/* Desktop Row */}
                                                <div className="hidden md:grid grid-cols-12 gap-2 px-3 py-1.5 items-center">
                                                    
                                                    {/* Cột 1: Nguồn */}
                                                    <div className="col-span-2 flex items-center gap-1.5 overflow-hidden">
                                                        <div className="w-6 h-6 rounded-md bg-white/60 flex-shrink-0 flex items-center justify-center text-slate-400 shadow-sm border border-white/50">
                                                            <IconSource />
                                                        </div>
                                                        <span className="text-[11px] font-semibold text-slate-700 truncate">{task.name}</span>
                                                    </div>

                                                    {/* Cột 2: Đối tượng (Badge trắng tinh tế) */}
                                                    <div className="col-span-3 flex flex-col justify-center">
                                                        <div className="flex items-center gap-1 w-fit bg-white/70 px-1.5 py-0.5 rounded border border-pink-100/50 shadow-sm">
                                                            <IconIdentity />
                                                            <span className="text-[11px] font-bold text-pink-600 truncate max-w-[140px]" dangerouslySetInnerHTML={{ __html: task.account_name }} />
                                                        </div>
                                                        {(task.amount && task.amount != '0') && (
                                                            <span className="text-[9px] text-slate-400 font-mono mt-0.5 ml-0.5" dangerouslySetInnerHTML={{ __html: task.amount }} />
                                                        )}
                                                    </div>

                                                    {/* Cột 3: Mô tả (Chữ nhỏ, màu tối dễ đọc) */}
                                                    <div className="col-span-4 pr-2">
                                                        <p className="text-[11px] text-slate-600 leading-snug line-clamp-1" dangerouslySetInnerHTML={{ __html: task.description_scam }} />
                                                    </div>

                                                    {/* Cột 4: Thời gian */}
                                                    <div className="col-span-2 flex justify-center">
                                                        <span className="text-[10px] text-slate-400 flex items-center gap-1">
                                                            <span dangerouslySetInnerHTML={{ __html: task.updatedate }} />
                                                        </span>
                                                    </div>

                                                    {/* Cột 5: Nút bấm (Trắng, chữ hồng, đổ bóng nhẹ) */}
                                                    <div className="col-span-1 flex justify-end">
                                                        <span className="text-[10px] font-bold text-pink-500 bg-white hover:bg-pink-50 border border-pink-100 px-2 py-1 rounded shadow-sm hover:shadow transition-all whitespace-nowrap inline-block">
                                                            {nutorder}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Mobile Row */}
                                                <div className="md:hidden p-2 flex flex-col gap-1.5 border-b border-white/30">
                                                    <div className="flex justify-between items-center">
                                                        <div className="flex items-center gap-1.5">
                                                            <span className="text-[11px] font-bold text-slate-700">{task.name}</span>
                                                            <span className="text-[9px] text-slate-400">•</span>
                                                            <span className="text-[9px] text-slate-400" dangerouslySetInnerHTML={{ __html: task.updatedate }} />
                                                        </div>
                                                        <div className="bg-white/80 px-1.5 py-0.5 rounded text-pink-600 text-[10px] font-bold border border-pink-100 shadow-sm" dangerouslySetInnerHTML={{ __html: task.account_name }} />
                                                    </div>
                                                    <div className="text-[11px] text-slate-600 line-clamp-2" dangerouslySetInnerHTML={{ __html: task.description_scam }} />
                                                </div>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                                
                                {/* 2.3 Pagination Footer (Trong suốt để hòa nền) */}
                                {total_lists && (
                                    <div className="p-1.5 border-t border-white/40 bg-white/20 flex justify-center">
                                        <Pagination totalLists={total_lists} limit={20} page={page} setPage={setPage} />
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
            
            {isOpen && (
               <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/5 backdrop-blur-[1px]" onClick={() => setIsOpen(false)}></div>
            )}
        </div>
    );
};

export default TaskList;
